'use client'

import { usePeopleData } from './select-people'
import { PeoplePageClient } from './page-client'

function PeopleSkeleton() {
  return (
    <div className="space-y-5 sm:space-y-6">
      {/* Header skeleton */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="bg-muted h-7 w-24 animate-pulse rounded" />
          <div
            className="bg-muted mt-1.5 h-4 w-16 animate-pulse rounded"
            style={{ animationDelay: '75ms' }}
          />
        </div>
        <div
          className="bg-muted h-11 w-full animate-pulse rounded-lg sm:h-8 sm:w-40"
          style={{ animationDelay: '150ms' }}
        />
      </div>

      {/* Filter pills skeleton */}
      <div className="flex gap-1.5 border-b pb-3">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-muted h-8 w-16 animate-pulse rounded-md"
            style={{ animationDelay: `${150 + i * 50}ms` }}
          />
        ))}
      </div>

      {/* People list skeleton */}
      <div className="space-y-0">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="flex items-center gap-3 border-b py-3"
            style={{ animationDelay: `${300 + i * 75}ms` }}
          >
            <div
              className="bg-muted h-10 w-10 animate-pulse rounded-full"
              style={{ animationDelay: `${300 + i * 75}ms` }}
            />
            <div className="flex-1 space-y-2">
              <div
                className="bg-muted h-4 w-32 animate-pulse rounded"
                style={{ animationDelay: `${325 + i * 75}ms` }}
              />
              <div
                className="bg-muted h-3 w-20 animate-pulse rounded"
                style={{ animationDelay: `${350 + i * 75}ms` }}
              />
            </div>
            <div
              className="bg-muted h-3 w-16 animate-pulse rounded"
              style={{ animationDelay: `${375 + i * 75}ms` }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export function PeopleWrapper() {
  const { data, isLoading } = usePeopleData()

  if (isLoading || !data) {
    return <PeopleSkeleton />
  }

  return <PeoplePageClient initialPeople={data} />
}
